import { drawerFilters, getColumns } from './helpers'
import { useMemo, useState } from 'react'
import { toTableRowItems } from './serializers'
import { makeCoreGetFileRequest, makeCoreGetRequest, makeCorePostRequest } from "utils/api";
import { Table } from 'components/core-ui/Table'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { useMutation, useQuery } from 'react-query'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import s from '../../../commonStyles.modules.scss'
import sModal from 'components/core-ui/Modal/Modal.modules.scss'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { getDepositCodeOptions, getScreenPermissions, getShopOptions } from '../../api'
import { SCREENS } from '../../constants'
import { formatAndDownloadResponse } from "../../../../../utils/helpers";

const ReceptionFiles = () => {
  const { showNotification } = useNotification()
  const [tableItems, setTableItems] = useState<any[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [reimportSelectedRowId, setReimportSelectedRowId] = useState(null)

  const [isOpen, setIsOpen] = useState(false)
  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const selectRow = id => {
    setReimportSelectedRowId(id)
    openModal()
  }

  const { data: permissions } = getScreenPermissions(showNotification, SCREENS.ADMIN_INFOLOG)

  const columns = useMemo(
    () => getColumns( (id) => exportReception(id), selectRow, permissions?.canDownload),
    [permissions?.canDownload]
  )

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/reception-files',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
      setIsLoading(false)
    }
  }

  const { data: shopCodes } = getShopOptions(showNotification)

  const { data: depositOptions } = getDepositCodeOptions(showNotification)

  const { data: reasonsOptions, isLoading: isReasonsOptionsLoading } = useQuery(
    ['hubs'],
    async () => {
      const data = await makeCoreGetRequest(`/shop-reception/reception-files/reasons`)
      return data.map(item => ({
        label: item.value,
        value: item.key
      }))
    },
    {
      onError: error => {
        showNotification({
          message: `A apărut o eroare la obtinerea huburilor. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { mutate: exportReception, isLoading: isExporting } = useMutation(
    async (id: string) => {
      return await makeCoreGetFileRequest(`/shop-reception/reception-files/${id}/export`, { responseType: 'blob' })
    },
    {
      onSuccess: (response) => {
        formatAndDownloadResponse(response)
      },
      onError: (error) => {
        console.log('showing notification...');
        showNotification({
          message: `A apărut o eroare. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const mutateReimport = async () => {
    await makeCorePostRequest(`/shop-reception/reception-files/${reimportSelectedRowId}/reimport`)
  }

  const { isLoading: isLoadingMutation, mutate } = useMutation(mutateReimport, {
    onSuccess: () => {
      closeModal()
      showNotification({
        message: `Operatiunea a avut succes.`,
        type: 'success'
      })
      setShouldRefreshData(true)
    },
    onError: res => {
      showNotification({
        message: `${formatErrorMessage(res)}`,
        type: 'error'
      })
    }
  })

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActionsWidth="130px"
        filters={drawerFilters(shopCodes, depositOptions, reasonsOptions)}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />

      <Modal
        isModalOpen={isOpen}
        closeModal={closeModal}
        modalTitle={
          'Eşti sigur că doreşti să reimporti fişierul? Rezultatele vor fi vizibile peste câteva minute.'
        }
      >
        <Grid container spacing={4}>
          <Grid xs={12} item className={sModal.modalButtons}>
            <Button variant="outlined" label={'Nu'} onClick={() => closeModal()} />
            <Button
              variant="contained"
              label={'Da'}
              onClick={() => mutate()}
              disabled={isLoadingMutation}
            />
          </Grid>
        </Grid>
      </Modal>
    </div>
  )
}

export default ReceptionFiles
